import { render } from "./InterviewPassedAction.vue?vue&type=template&id=36008cbb"
import script from "./InterviewPassedAction.vue?vue&type=script&lang=js"
export * from "./InterviewPassedAction.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nisalatp/Projects/Herd/OrangeHRM/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__